import React from 'react';
import { Grid } from '@material-ui/core';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import { makeStyles } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useIntl } from 'react-intl';
import { AssuranceIcon } from 'images';

export interface PracticalCardButtonListType {
  items: any;
  direction?: any;
  spacing?: any;
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(13),
    flexBasis: '80%',
    fontFamily: 'Roboto',
    color: '#575E71',
    fontWeight: 'normal',
    alignSelf: 'center',
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
    flexBasis: '100%',
  },
  accordionDetails: {
    flexDirection: 'column',
    paddingTop: 0,
  },
  bullet: {
    fontFamily: 'Roboto',
    color: '#575E71',
    fontWeight: 'bold',
  },
  check: {
    paddingLeft: '16px',
    fontFamily: 'Roboto',
    color: '#575E71',
  },
  bulle: {
    paddingLeft: '18px',
    fontFamily: 'Roboto',
    color: '#575E71',
  },
  description: {
    fontFamily: 'Roboto',
    color: '#575E71',
  },
  secondDescription: {
    fontFamily: 'Roboto',
    color: '#575E71',
    marginTop: '8px',
  },
}));

const PracticalCardButtonList = ({
  items,
  direction,
  spacing,
}: PracticalCardButtonListType) => {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState<boolean | string>(false);

  const handleChange = (panel: any) => (_event: any, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };

  const intl = useIntl();

  return (
    <Grid
      container
      direction={direction}
      spacing={spacing}
      style={{ marginTop: '12px', marginBottom: '8px', width: '100%' }}
    >
      {items.map((item: any, index: number) => (
        <Accordion
          expanded={expanded === `panel${index}`}
          onChange={handleChange(`panel${index}`)}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <img
              style={{ marginRight: '6px' }}
              alt=""
              src={AssuranceIcon['procedures']}
            />
            <Typography className={classes.heading}>
              {intl.formatMessage({
                id: item.title,
              })}
            </Typography>
          </AccordionSummary>
          <AccordionDetails className={classes.accordionDetails}>
            {item.descript?.map((description: any) => (
              <>
                <Typography className={classes.bullet}>
                  {'• ' +
                    intl.formatMessage({ id: description.titleDescription })}
                </Typography>
                {description.firstDescription && (
                  <Typography className={classes.description}>
                    {intl.formatMessage({ id: description.firstDescription })}
                  </Typography>
                )}
                {description?.desc?.map((d: any) => (
                  <>
                    <Typography className={classes.check}>
                      {d.title && '- ' + intl.formatMessage({ id: d.title })}
                    </Typography>
                    <Typography className={classes.check}>
                      {d.desc && intl.formatMessage({ id: d.desc })}
                    </Typography>
                    {d?.descBulle?.map((bulle: any) => (
                      <Typography className={classes.bulle}>
                        {bulle.bulle && intl.formatMessage({ id: bulle.bulle })}
                      </Typography>
                    ))}
                  </>
                ))}
                {description.secondDescription && (
                  <Typography className={classes.secondDescription}>
                    {intl.formatMessage({ id: description.secondDescription })}
                  </Typography>
                )}
                <div style={{ marginTop: '20px' }}></div>
              </>
            ))}
          </AccordionDetails>
        </Accordion>
      ))}
    </Grid>
  );
};

export default PracticalCardButtonList;
